import React, {} from "react"
import VideoJS from '../VideoJS';
import '../../../css/InfluencerUpload.css'

export default function MediaContentVideo(props) {
   const playerRef = React.useRef(null);
   const videoJsOptions = {
      controls: false,
      loop: true,
      responsive: true,
      fill: true,
      sources: [{
         src: props.file,
         type: 'video/mp4'
      }],
      poster: props.thumbnail
   }
   const handlePlayerReady = (player) => {
      playerRef.current = player;

      // You can handle player events here, for example:
      player.on('waiting', () => {
         // console.log('player is waiting');
      });

      player.on('dispose', () => {
         // console.log('player will dispose');
      });
   };
    return (
      <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
   )
}
